import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
var SocialShareProvidersEnum = t.keyof({
  facebook: null,
  twitter: null,
  linkedin: null
});
var LinkInfoInput = t.type({
  image: t.string,
  imageUrl: t.string,
  url: t.string,
  originalUrl: t.string,
  title: t.string,
  description: t.string
});
export var ShareContentInput = t.type({
  input: t.type({
    id: t.string,
    message: t.string,
    provider: SocialShareProvidersEnum,
    linkInfo: nullable(LinkInfoInput)
  })
});
export var ShareContentErrors = t.type({
  __typename: t.literal('ShareContentErrors'),
  errors: t.array(t.type({
    __typename: t.string,
    message: t.string
  }))
});
export var ShareContentOutput = t.type({
  shareContent: t.union([t.type({
    __typename: t.literal('ShareContentResult'),
    message: t.string
  }), ShareContentErrors])
});